import React, { useState } from 'react';
import { Spinner } from 'baseui/spinner';
import { useGetUserGroups } from '../../hooks/use-get-user-groups';
import { useGetUsers } from '../../hooks/use-get-users';
import GroupManagement from './group-management';
import UserManagement from './user-management';
type UserGroupProps = {
  active: string;
};
const UserGroup = (props: UserGroupProps) => {
  const [pageNumber, setPageNumber] = useState<number>(1);
  const {
    data,
    isLoading,
    error
  } = useGetUsers(pageNumber, 100);
  const {
    data: groupData,
    isLoading: isGetGroupLoading,
    error: getGroupError
  } = useGetUserGroups();
  if (error || getGroupError) {
    return <div>Error: {error?.message || getGroupError?.message}</div>;
  }
  if (isLoading || isGetGroupLoading) {
    return <Spinner />;
  }
  const {
    users,
    page,
    totalPages
  } = data!;
  const {
    groups,
    users: groupUsers
  } = groupData!;
  if (props.active === 'User Management') {
    return <UserManagement users={users} pageNumber={page} totalPages={totalPages} setPageNumber={setPageNumber} />;
  } else {
    return <GroupManagement groups={groups} users={groupUsers} />;
  }
};
export default UserGroup;